import {setCaptchaStatus, CaptchaStatuses, setCaptchaToken} from 'app/store/registration/registrationSlice';
import {useDispatch} from 'react-redux';
import Turnstile from 'react-turnstile';

const TurnstileWidget = () => {
  const dispatch = useDispatch();
  const site_key = process.env.REACT_APP_TURNSTILE_SITE_KEY ? process.env.REACT_APP_TURNSTILE_SITE_KEY : '';

  return (
    <Turnstile
      sitekey={site_key}
      onError={() => dispatch(setCaptchaStatus(CaptchaStatuses.Error))}
      onExpire={() => dispatch(setCaptchaStatus(CaptchaStatuses.Expired))}
      onVerify={(token) => {
        dispatch(setCaptchaToken(token));
        dispatch(setCaptchaStatus(CaptchaStatuses.Solved));
      }}
      onLoad={(widgetId) => console.log('Widget loaded', widgetId)}
    />
  );
};

export default TurnstileWidget;
